import { Injectable } from '@angular/core';
import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

@Injectable()
export class CustomUrlSerializer implements UrlSerializer {
  parse(url: any): UrlTree {
    return new DefaultUrlSerializer().parse(url);
  }
  serialize(tree: UrlTree): any {
    const path = new DefaultUrlSerializer().serialize(tree);
    try {
      // we have special characters in our route parameters
      // eg. productID ASVFFS|IHIUI-dfsg-sad
      // since browser already encodes | => %7C, restrict angular's % => %25 encoding
      // const route = path.split('/').filter(d => !!d);
      if (
        tree.root.hasChildren() &&
        tree.root.children.primary.segments[0].path === 'products' &&
        tree.root.children.primary.segments.length === 2
      ) {
        // route[0].split('?')[0].toLowerCase() === 'products' && route.length === 2) {
        // check product page
        const tmp = path.split('?');
        let uri = decodeURIComponent(decodeURIComponent(tmp[0]));
        const params = tmp.length > 1 ? '?' + tmp[1] : '';
        uri = '/products/' + uri.split('/products/')[1].replace(/\//g, '%2F');
        return uri + params;
      }
      return path;
    } catch (error) {
      return path;
    }
  }
}
